export const CAMERA_BUBBLE_SIZE_PX = 144;
export const CAMERA_BUBBLE_MARGIN_PX = 24;

export const CAMERA_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 640 },
  height: { ideal: 480 },
};

export const cameraPrefKey = (projectId: string) =>
  `ts_ut_camera_pref_${projectId}`;
